<template>
  <div ref="strip" class="s-fleet">
    <div class="page-container">
      <Loader v-if="isLoading" display="absolute"></Loader>
      <Alert
        v-if="errorMsgs.length"
        type="danger"
        :messages="errorMsgs"></Alert>

      <MilesNBonusBanner class="mb-80" />

      <div class="s-fleet__progress-bar d-flex d-lg-none">
        <ProgressBar :percentage="percentage" />
      </div>

      <div class="s-fleet__header mb-40">
        <div class="h2">{{ dictionary.countryLabel }}</div>
        <div class="s-fleet__tools">
          <div v-if="countries.length" class="s-fleet__countries">
            <select
              v-model="country"
              class="form-select form-select-short"
              @change="onChangeCountry">
              <option
                v-for="item in countries"
                :key="item.value"
                :value="item.value">
                {{ item.text }}
              </option>
            </select>
          </div>
          <div v-if="types.length" class="s-fleet__my-filters">
            <span class="semibold">{{ dictionary.filtersLabel }}</span>

            <FleetFilters
              :key="keyFilters"
              :vehicles-types="vehiclesTypes"
              :types="types"
              @submit-filters="onSubmitFilters" />
          </div>
        </div>
      </div>

      <!-- desktop -->
      <div class="d-none d-lg-block">
        <div
          v-if="recordsCountFiltered"
          v-auto-animate
          class="s-fleet__grid"
          :class="{ 'mb-60': viewMoreLink }">
          <div
            v-for="item in recordsFilteredPaged"
            :key="item.id"
            class="s-fleet__item">
            <Vehicle
              :key="key"
              :item="item"
              @book-fleet-vehicle="onBookFleetVehicle" />
          </div>
        </div>
      </div>

      <!-- devices -->
      <div class="d-block d-lg-none">
        <SlickCarousel
          v-if="recordsCountFiltered"
          ref="slick"
          :key="slickKey"
          class="s-fleet__slick mb-60"
          :options="slickOptions"
          @init="onInit"
          @beforechange="onBeforeChange">
          <div
            v-for="(item, index) in recordsFiltered"
            :key="index"
            class="s-fleet__slide item">
            <Vehicle :item="item" @book-fleet-vehicle="onBookFleetVehicle" />
          </div>
        </SlickCarousel>
      </div>

      <div v-if="!recordsCountFiltered">
        <NoResults></NoResults>
      </div>
    </div>

    <div class="page-container">
      <div class="s-fleet__footer">
        <Anchor
          v-if="viewMoreLink"
          :item="viewMoreLink"
          class="btn btn-outline-primary" />
      </div>
    </div>
  </div>

  <div
    id="modalVehicleForBooking"
    class="modal s-modal s-modal--success"
    tabindex="-1"
    role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title">
            <div><i class="icon-check"></i></div>
            <div>{{ dictionary.modalVehicleForBookingTitle }}</div>
          </div>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close">
            <i class="icon-close-light"></i>
          </button>
        </div>
        <div class="modal-body">
          <p>{{ formattedModalVehicleForBookingText }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as lib from '../../lib/lib'
import axios from 'axios'
import Vehicle from '../components/Vehicle.vue'
import Loader from './../components/common/Loader.vue'
import Alert from './../components/common/Alert.vue'
import NoResults from './../components/common/NoResults.vue'
import Anchor from './../components/common/Anchor.vue'
import FleetFilters from './../components/FleetFilters.vue'
import ProgressBar from './../components/common/ProgressBar.vue'
import SlickCarousel from '../components/common/SlickCarousel.vue'
import { v4 as uuidv4 } from 'uuid'
/* eslint-disable no-unused-vars */
import { compact, uniqBy } from 'lodash'
import MilesNBonusBanner from './../components/MilesNBonusBanner.vue'
import { Modal } from 'bootstrap'

export default {
  components: {
    ProgressBar,
    SlickCarousel,
    FleetFilters,
    Anchor,
    Alert,
    Loader,
    NoResults,
    Vehicle,
    MilesNBonusBanner,
  },

  data() {
    return {
      keyFilters: uuidv4(),
      key: uuidv4(),
      percentage: 0,
      isLoading: false,
      errorMsgs: [],
      records: [],
      recordsCount: null,
      recordsFiltered: [],
      viewMoreLink: null,
      countries: [],
      country: '',
      types: [],
      page: 1,
      itemsPerPage: this.configuration.itemsPerPage,
      slickKey: uuidv4(),
      slickOptions: {
        infinite: false,
        autoplay: false,
        arrows: true,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
      },
      vehiclesTypes: [],
      modalVehicleForBooking: null,
      modalTimeout: null,
      modalTimeoutDelay: 5000,
      vehicleForBookingGroup: null,
    }
  },
  computed: {
    recordsFilteredPaged() {
      const start = (this.page - 1) * this.itemsPerPage
      const end = this.page * this.itemsPerPage
      return this.recordsFiltered.slice(start, end)
    },

    recordsCountFiltered() {
      return this.recordsFiltered.length
    },

    formattedModalVehicleForBookingText() {
      return this.dictionary.modalVehicleForBookingTextPrefix.replace(
        '{0}',
        this.vehicleForBookingGroup
      )
    },
  },
  mounted() {
    const { types, countries, viewMoreLink } = lib.getData('fleetData')
    this.types = types
    this.countries = countries
    this.viewMoreLink = viewMoreLink

    this.setPreselectedCountry()
    this.fetchData()

    const modalElement = document.getElementById('modalVehicleForBooking')
    this.modalVehicleForBooking = new Modal(modalElement)
  },
  methods: {
    /* eslint-disable no-undef */
    setVehiclesTypes() {
      const arr = this.records.map((i) => i.Categories.split('|')).flat()
      const newArr = _.compact(arr)
      this.vehiclesTypes = _.uniqBy(newArr)
      this.keyFilters = uuidv4()
    },

    onSubmitFilters(categories) {
      this.key = uuidv4()

      if (!categories.length) {
        this.recordsFiltered = this.records
        this.slickKey = uuidv4()
        return false
      }
      // https://stackoverflow.com/questions/16312528/check-if-an-array-contains-any-element-of-another-array-in-javascript
      this.recordsFiltered = this.records.filter((i) =>
        i.Categories.split('|').some((r) => categories.indexOf(r) >= 0)
      )
      this.slickKey = uuidv4()
    },

    setPreselectedCountry() {
      const entry = this.countries.find((i) => i.selected)
      this.country = entry ? entry.value : ''
    },

    onChangeCountry() {
      this.fetchData()
    },

    fetchData() {
      this.isLoading = true

      let postData = {
        countryCode: this.country,
      }
      if (this.configuration.filterCategory){
        postData = Object.assign(postData,{filterCategory:this.configuration.filterCategory})
      }
      axios
        .post(this.configuration.endpointFetchData, postData)
        .then((response) => {
          const { hasError, errorMessages, CarsView } = response.data
          // response has error
          if (hasError) {
            this.handleError(errorMessages)
            return false
          }

          this.records = this.recordsFiltered = CarsView
          this.recordsCount = this.records.length
          this.key = uuidv4()
          this.slickKey = uuidv4()
          this.setVehiclesTypes()

          this.handleSuccess()
        })
        .catch((errors) => {
          this.handleError([this.dictionary.defaultErrorMessage])
          console.error(errors)
        })
    },

    handleSuccess() {
      this.errorMsgs = []
      this.isLoading = false
    },

    handleError(messages) {
      this.errorMsgs = messages
      this.isLoading = false
    },

    onInit(event, slick) {
      this.percentage = lib.getSlickProgressBarPercentage(slick)
    },

    onBeforeChange(event, slick) {
      setTimeout(() => {
        this.percentage = lib.getSlickProgressBarPercentage(slick)
      }, 100)
    },

    onBookFleetVehicle(vehicle) {
      this.vehicleForBookingGroup = `Group ${vehicle.Name}`
      this.modalVehicleForBooking.show()

      clearTimeout(this.modalTimeout)

      this.modalTimeout = setTimeout(() => {
        this.modalVehicleForBooking.hide()
      }, this.modalTimeoutDelay)
    },
  },
}
</script>
